<template>
  <FaqAndSupportContactsCard
    :label="label"
    :text="text"
    :is-active="isActive"
    class="contacts-card-with-copy"
    @click.native="copyText(textToCopy)"
  >
    <div class="contacts-card-with-copy__icon-wrapper">
      <div class="contacts-card-with-copy__icon">
        <transition name="fade">
          <VIconMTS
            v-if="isActive"
            key="success"
            name="faq_and_support/icon-success"
            width="32"
            height="32"
          />
          <VIconMTS
            v-else
            key="copy"
            name="faq_and_support/icon-copy"
            width="32"
            height="32"
          />
        </transition>
      </div>
      <transition name="fade">
        <span v-if="isActive">Почта скопирована</span>
      </transition>
    </div>
  </FaqAndSupportContactsCard>
</template>

<script>
import FaqAndSupportContactsCard from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContactsCard.vue'
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import FaqAndSupportContactsMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportContactsMixin'

export default {
  name: 'FaqAndSupportContactsCardWithCopy',
  components: { VIconMTS, FaqAndSupportContactsCard },
  mixins: [FaqAndSupportContactsMixin],
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    textToCopy: {
      type: String,
      default: '',
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.contacts-card-with-copy {
  &__icon-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      max-width: 88px;
      font-family: $font-mts-compact;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: $color-gray-1;
      user-select: none;
    }
  }

  &__icon {
    position: relative;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    background-color: $color-light;

    svg {
      position: absolute;
      inset: 0;
      margin: auto;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
